<div class="d-flex justify-content-center align-items-center h-100 col-sm-12">
  <div class="loader"></div>
</div>
